import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import infoIcon from '../../../assets/icons/info.svg';

const Tooltip = ({ content, class_name }) => {
    const [showContent, setShowContent] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);

    // Update position of the tooltip based on the trigger icon
    const updatePosition = () => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setCoords({
                // Adjusting to match your "left-8" and centered logic
                top: rect.top + rect.height / 2 + window.scrollY,
                left: rect.left + rect.width + 8 + window.scrollX,
            });
        }
    };

    const handleClickOutside = (event) => {
        if (
            tooltipRef.current && !tooltipRef.current.contains(event.target) &&
            triggerRef.current && !triggerRef.current.contains(event.target)
        ) {
            setShowContent(false);
        }
    };

    useEffect(() => {
        if (showContent) {
            updatePosition();
            window.addEventListener('scroll', updatePosition);
            window.addEventListener('resize', updatePosition);
            document.addEventListener('click', handleClickOutside, true);
        }

        return () => {
            window.removeEventListener('scroll', updatePosition);
            window.removeEventListener('resize', updatePosition);
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [showContent]);

    return (
        <div className={`absolute transform -translate-y-1/2 ${class_name}`} ref={triggerRef}>
            <span
                className="w-4 h-4 rounded-full cursor-pointer block"
                onClick={() => setShowContent(!showContent)}
            >
                <img src={infoIcon} alt="info" className='w-full' />
            </span>

            {showContent && createPortal(
                <div
                    ref={tooltipRef}
                    style={{
                        position: 'absolute',
                        top: `${coords.top}px`,
                        left: `${coords.left}px`,
                        transform: 'translateY(-50%)' // Keeps it vertically centered to the icon
                    }}
                    className="z-[9999] inline-block px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm w-32"
                >
                    {content}
                    {/* Arrow */}
                    <div className="tooltip-arrow h-0 w-0 border-y-8 border-y-transparent border-r-[8px] border-r-gray-900 absolute left-[-8px] top-[50%] -translate-y-1/2"></div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default Tooltip;